import { Space, Popover } from 'antd';
import React, { useState } from 'react';
import { useModel, } from '@umijs/max';
import Avatar from './AvatarDropdown';
import { Avatar as AntdAvatar } from 'antd';
import HeaderSearch from '../HeaderSearch';
import styles from './index.less';
import { search } from '@/services/crm/api';

export type SiderTheme = 'light' | 'dark';

const GlobalHeaderRight: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const [searchResult, setSearchResult] = useState<any[]>([]);

  if (!initialState || !initialState.settings) {
    return null;
  }
  const { navTheme, layout } = initialState.settings;
  let className = styles.right;

  if ((navTheme === 'dark' && layout === 'top') || layout === 'mix') {
    className = `${styles.right}  ${styles.dark}`;
  }
  return (
    <Space className={className}>
      <HeaderSearch
        className={`${styles.action} ${styles.search}`}
        placeholder="站内搜索"
        defaultValue=""
        options={
          searchResult.map((item: any) => {
            if (item.type == "external-contact") {
              return { label: <a href={`/qywx/external-contact-detail?id=${item.id}`}><AntdAvatar src={item.avatar} /> {item.name}</a>, value: item.name }
            }
            return { label: <a href={`/crm/${item.type}/detail?id=${item.id}`}>{item.name}</a>, value: item.name }
          }) || []
        }
        onSearch={async value => {
          if (value) {
            const res = await search(value)
            setSearchResult(res.data)
          }
        }}
        onChange={async value => {
          if (value) {
            // const res = await search(value)
            // setSearchResult(res.data)
          }
        }}
      />
      {/* <span
        className={styles.action}
        onClick={() => {
          window.open('https://pro.ant.design/docs/getting-started');
        }}
      >
        <SettingOutlined />    设置
      </span> */}
      <Popover placement="bottom" content={<div><img width={200} src="https://fornt-end.oss-cn-shanghai.aliyuncs.com/crm/pc/images/%E5%AE%A2%E6%9C%8D.jpg" /></div>} >
        <a>联系客服</a>
      </Popover>
      <Avatar />
      {/* <SelectLang className={styles.action} /> */}

    </Space>
  );
};
export default GlobalHeaderRight;

import { QuestionCircleOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang } from '@umijs/max';


export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const Question: React.FC = () => {
  return (
    <a
      href="https://pro.ant.design/docs/getting-started"
      target="_blank"
      rel="noreferrer"
      style={{
        display: 'inline-flex',
        padding: '4px',
        fontSize: '18px',
        color: 'inherit',
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};
